module.exports = __webpack_public_path__ + "static/img/high.19150f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/high.png
// module id = iM4C
// module chunks = 18